/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from "react";
import ContentLoader from "react-content-loader";
import {SkeletonSettings} from "../../../../../../atoms/effects/skeletons/utils/SkeletonSettings";

export const PaymentCardSkeleton = (props) => (
    <ContentLoader
        height={100}
        width={"100%"}
        speed={SkeletonSettings.SPEED}
        backgroundColor={SkeletonSettings.BACKGROUND}
        foregroundColor={SkeletonSettings.FOREGROUND}
        style={{border: SkeletonSettings.BORDER, borderRadius: "4px"}}
        {...props}>

        {/* Radio button */}
        <circle cx="5%" cy="50%" r="8"/>

        {/* Title */}
        <rect x="10%" y={`calc(35% - 10px)`} rx="3" ry="3" width="25%" height="10"/>

        {/* Price */}
        <rect x="85%" y={`calc(35% - 10px)`} rx="3" ry="3" width="10%" height="10"/>

        {/* Divider */}
        <rect x="10%" y="50%" rx="3" ry="3" width="85%" height="1"/>

        {/* Description */}
        <rect x="10%" y="70%" rx="3" ry="3" width="60%" height="10"/>

    </ContentLoader>
)
